import { useFormContext } from 'react-hook-form';
import { IForgotPasswordFormData } from '../../../domain/models/IForgotPasswordFormData';

export function useForgotPasswordFormContext() {
	return useFormContext<IForgotPasswordFormData>();
}
